import { useState } from "react";

import { startCase } from "lodash";

import { Badge, Text } from "@alpacahq/ui/old";

import { useGetEliteAlgoRouting } from "~/v2/api/hooks";
import { Page } from "~/v2/components";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { CommissionModelModal } from "./CommissionModelModal";
import { PLANS } from "./constant";
import { OrderFlowDisclosureModal } from "./OrderFlowDisclosureModal";
import { PlanBox } from "./PlanBox";
import { PlanTable } from "./PlanTable";

const TradingPlan = () => {
  const { currentAccount } = useAccountContext({ liveOnly: true });
  const [isOrderFlowDisclosureModalOpen, setIsOrderFlowDisclosureModalOpen] =
    useState(false);
  const [isCommissionModelModalOpen, setIsCommissionModelModalOpen] =
    useState(false);

  const { model } = useGetEliteAlgoRouting({
    accountID: currentAccount?.id || "",
    options: {
      enabled: !!currentAccount?.id,
    },
  });

  const plan =
    model === "cost_plus" || model === "all_in"
      ? "Elite Smart Router"
      : "Commission-Free";

  const handlePlanClick = (plan: "basic" | "elite") => () => {
    if (plan === "elite") {
      // User must acknowledge order flow disclosure before selecting a commission model
      setIsOrderFlowDisclosureModalOpen(true);
    }
  };

  // show commission model modal after order flow disclosure is acknowledged
  const onOrderFlowDisclosureComplete = () => {
    setIsOrderFlowDisclosureModalOpen(false);
    setIsCommissionModelModalOpen(true);
  };

  return (
    <Page
      title="Trading Plans"
      subtitle={
        <Text className="flex items-center">
          Current Trading Plan:
          <Badge variant={"blue"} className="ml-2">
            {`${plan}: ${startCase(model)}`}
          </Badge>
        </Text>
      }
    >
      <Text className="font-bold text-2xl">
        Perfect trading plans for every stage of your trading journey
      </Text>

      <div className="w-full max-w-4xl pb-10">
        <div className="grid w-full grid-cols-3 justify-center pb-4">
          <div></div>
          <PlanBox
            {...PLANS.basic}
            button={{
              text: model === "retail" ? "Enabled" : "Not Enabled",
              variant: "alternate",
              onClick: handlePlanClick("basic"),
              // There is no action here, people cannot apply to be 'basic'. So this is always disabled.
              disabled: true,
            }}
          />
          <PlanBox
            {...PLANS.elite}
            button={{
              text: model === "retail" ? "Select" : "Enabled",
              variant: "default",
              onClick: handlePlanClick("elite"),
              disabled: currentAccount?.elite_status === null, // only allow for elite users
            }}
          />
        </div>
        <PlanTable />
      </div>

      {currentAccount && (
        <>
          <OrderFlowDisclosureModal
            isOpen={isOrderFlowDisclosureModalOpen}
            setIsOpen={setIsOrderFlowDisclosureModalOpen}
            onComplete={onOrderFlowDisclosureComplete}
          />
          <CommissionModelModal
            isOpen={isCommissionModelModalOpen}
            setIsOpen={setIsCommissionModelModalOpen}
            account={currentAccount}
            model={model}
          />
        </>
      )}
    </Page>
  );
};

export default TradingPlan;
